import * as yup from 'yup'
import { PersonDto } from './personDto'

export class VehicleExporterNoteDto {
  note?: string = undefined
  createdBy?: PersonDto = undefined
  createdDateTime?: string = undefined
}

export const VehicleExporterNoteValidationSchema = yup.object({
  note: yup.string().max(200, 'Exporter Notes cannot be more than 200 characters').nullable()
})
